// extracted by mini-css-extract-plugin
module.exports = {"section":"sponsors_section__kEKpO","container":"sponsors_container__2T-kB","content":"sponsors_content__2OIZ9","logoHover":"sponsors_logoHover__1mA2c"};